import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Role } from '../enums/user.enum';
import { IUser } from '../interfaces/user.interface';

@Injectable({
    providedIn: 'root'
})
export class MigrationNoticeService {
    private readonly storageKeyPrefix = 'chi-migration-notice-v1';
    private readonly dashboardPath = '/client-dashboard';
    private readonly acknowledgedSubject = new Subject<void>();

    noticeAcknowledged$ = this.acknowledgedSubject.asObservable();

    shouldShow(user: IUser | null, currentUrl: string): boolean {
        if (!this.isEligibleUser(user) || !this.isDashboardPath(currentUrl)) {
            return false;
        }

        return !this.hasSeenNotice(user.id);
    }

    markAsSeen(user: IUser | null): void {
        if (!this.isEligibleUser(user)) {
            return;
        }

        try {
            localStorage.setItem(this.getStorageKey(user.id), 'seen');
        } catch {
            // If browser storage is unavailable, avoid blocking the user.
        }

        this.acknowledgedSubject.next();
    }

    private isEligibleUser(user: IUser | null): user is IUser {
        return !!user?.id && (user.userType === Role.CLIENT || user.userType === Role.CREATOR);
    }

    private hasSeenNotice(userId: string): boolean {
        try {
            return localStorage.getItem(this.getStorageKey(userId)) === 'seen';
        } catch {
            return true;
        }
    }

    private getStorageKey(userId: string): string {
        return `${this.storageKeyPrefix}:${userId}`;
    }

    private isDashboardPath(currentUrl: string): boolean {
        const path = currentUrl.split('?')[0];
        return path === this.dashboardPath;
    }
}
